export const DEFAULT_WIN_ROAS = 1.2;
export const DEFAULT_WIN_SPEND = 300;
export function classifyDashboard(body, winRoas, winSpend) {
  if (!body) return body;
  const eligible = (body.campaigns || []).filter(c => Number(c.spend) >= winSpend);
  const winners = eligible.filter(c => Number(c.roas) >= winRoas);
  const winRate = eligible.length ? (winners.length / eligible.length * 100).toFixed(1) : '0.0';
  const counts = { eligibleCampaigns: eligible.length, winnerCampaigns: winners.length, winRate };
  return { ...body,
    analytics: { ...body.analytics, ...counts, totalCampaigns: (body.campaigns || []).length, winThresholdRoas: winRoas, winThresholdSpend: winSpend, winners: winners.map(c => c.name) },
    summary: { ...body.summary, ...counts, winRateMet: Number(winRate) >= 50, winRateMin: Number(winRate) >= 25 },
  };
}
